export default __webpack_public_path__ + "static/media/l10.869d9361.jpg";